import { Theme } from '../../ITheme';

const predatorPathTheme: Theme = {
  colors: {
    background: '#1B2B19', // jungle dark green
    background2: '#243D23', // secondary background
    background4: '#2A4A2A', // additional background layer
    slider: '#76C043', // slider color
    text2: '#CCCCCC', // secondary text color
    autoplayBtBgborder: '#76C04333', // autoplay button border
    qbet: '#76C043', // quick bet color
    primary: '#76C043', // bright jungle green
    secondary: '#f2b0aaff', // predator red
    text: '#f35757ff',
    overlay: 'rgba(27,43,25,0.85)', // dark forest overlay
    border: '#76C04333', // green transparent border
    betborder: '#76C04333', // bet border color
    betborderPress: '#5da836', // bet border press color
    betbutton: '#243D23', // bet button background
    stake: '#76C043', // stake color
    betHover: '#76C04366', // bet hover color
    betButtonHover: '#8CD95F', // bet button hover color
    betButtonPress: '0 0 0 0.2rem rgba(118, 192, 67, 0.5)', // bet button press shadow
    betCancelHover: '#f2b0aa', // bet cancel hover color (using secondary red)
    betCancelPress: '0 0 0 0.2rem rgba(242, 176, 170, 0.5)', // bet cancel press shadow
    betCancelPressMobile: '#c28d88', // bet cancel press mobile color
    betCashHover: '#9FE870', // bet cash hover color
    betCashPress: '0 0 0 0.2rem rgba(159, 232, 112, 0.5)', // bet cash press shadow
    betCashPressMobile: '#7fc45a', // bet cash press mobile color
    betButtonPressMobile: '#6fa84c', // bet button press mobile color
  },
  fonts: {
    primary: "'Bangers', cursive",
    secondary: 'Arial, sans-serif',
    button: "'Bangers', cursive",
  },
  uiElements: {
    button: {
      borderRadius: '8px',
      padding: '12px 20px',
      fontSize: '16px',
    },
    card: {
      borderRadius: '10px',
      shadow: '0 6px 14px rgba(0,0,0,0.25)',
    },
    modal: {
      borderRadius: '12px',
      background: '#243D23',
    },
  },
};

export default predatorPathTheme;
